import { frontendURL } from '../../../helper/URLHelper';
import { ROLES } from 'dashboard/constants/permissions';

const Kanban = () => import('./Kanban.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/kanban/tasks'),
      name: 'kanban_tasks',
      meta: { permissions: ROLES },
      component: () => import('./Tasks.vue'),
    },
    {
      path: frontendURL('accounts/:accountId/kanban'),
      name: 'kanban_index',
      meta: { permissions: ROLES },
      component: Kanban,
    },
  ],
};
